// Module
var code = "<span>{{$ctrl.totalWeight | bringozWeight:true}}</span> ";
// Exports
export default code;